/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Target_LanguagesInputs */



/**
* | output |
* | --- |
* | "Target Languages" |
*
* @param {Target_LanguagesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const target_languages = /** @type {((inputs?: Target_LanguagesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Target_LanguagesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Langues cibles")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zielsprachen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lingue di destinazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Целевые языки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Idiomas de destino")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("目标语言")
	if (locale === "ja") return /** @type {LocalizedString} */ ("対象言語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्ष्य भाषाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Línguas-alvo")
	return /** @type {LocalizedString} */ ("Target Languages")
});